import { IChecksum } from 'modules/reducers';

export const checksumsSelector = ({ checksums }: IChecksum) => checksums;
